<template>
  <div class="w-full">
    <vs-table
      maxHeight="68vh"
      noDataText=""
      search
      pagination
      max-items="10"
      :data="datas"
    >
      <template slot="header">
        <vs-row vs-w="12">
          <vs-col vs-w="6">
            <h4 style="color: #b4aa99">Datas especiais</h4>
          </vs-col>
          <vs-col vs-w="6">
            <ModalCadastroDataEspecial @update="getDatasEspeciais" />
          </vs-col>
        </vs-row>
      </template>
      <template slot="thead">
        <vs-th sort-key="nome">Nome</vs-th>
        <vs-th sort-key="data_marcada" class="center-th">Data</vs-th>
        <vs-th sort-key="nivel" class="center-th">Nivel</vs-th>
        <vs-th sort-key="ocio" class="center-th">Ocio</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :state="tr.lixeira == 1 ? 'danger' : ''"
          :key="indextr"
          v-for="(tr, indextr) in data"
        >
          <vs-td>{{ tr.nome }}</vs-td>
          <vs-td class="text-center">{{ tr.data_marcada }}</vs-td>
          <vs-td class="text-center">{{ tr.nivel ? "Sim" : "Não" }}</vs-td>
          <vs-td class="text-center">{{ tr.ocio ? "Sim" : "Não" }}</vs-td>
          <vs-td class="actions">
            <ModalEditarDataEspecial :data="tr" @update="getDatasEspeciais" />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div v-if="datas.length == 0">
      <div class="con-colors">
        <ul>
          <li class="danger-box">
            <h2 class="p-5" style="color: white !important">
              Nenhuma data cadstrada
            </h2>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ModalCadastroDataEspecial from "./cadastro";
import ModalEditarDataEspecial from "./editar";
export default {
  data() {
    return {
      datas: [],
    };
  },
  methods: {
    async getDatasEspeciais() {
      this.$vs.loading();
      try {
        this.datas = await this.$http.get(`datas-especiais`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  components: {
    ModalCadastroDataEspecial,
    ModalEditarDataEspecial,
  },
  mounted() {
    this.getDatasEspeciais();
  },
};
</script>

<style lang="scss">
.col {
  width: auto;
}
thead tr th.center-th {
  .vs-table-text {
    justify-content: center !important;
  }
}
.actions {
  width: 60px !important;
}
</style>
